module.exports = __webpack_public_path__ + "media/images/result_sets/circles/4r5r1n2r-23a50395a96168fa4346f805c42188e8.svg";